/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FrequencyViewModel } from './FrequencyViewModel'; 

export function getFrequencyOptions(frequencyId: string, onSuccess?: (result: FrequencyViewModel) => void) {
	return queryOptions({
		queryKey: ['frequency', frequencyId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/frequencies/queries/getfrequency/' + frequencyId;
			const resp = await axios.get<FrequencyViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(frequencyId)
	});
}